export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const DELETE_DEVICE_TOKEN = 'DELETE_DEVICE_TOKEN';
export const SET_DEVICE_TOKEN = 'SET_DEVICE_TOKEN';
